import React from 'react'
import useForm from '../../../hooks/useForm'
import ValidateInput from '../Form/ValidateInput'
import EditExtdFields from './EditExtdFields';

const requiredFieldMsg = (fieldName) => `Please enter ${fieldName}`;
const requiredSelectMsg = (fieldName) => `Please select ${fieldName}`;

function EditAlreadyMember(props) {
    const {
        handleChange,
        handleSubmit,
        setValues,
        updateError,
        values,
        errors
    } = useForm(savePersonCallback, validate);


    React.useEffect(() => {
        setValues(props.bowlerProfile || {});
    }, []);

    function formatPhoneNumber(value) {
        if (!value) return value;
        const phonenumber = value.replace(/[^\d]/g, '');
        const phonelength = phonenumber.length;
        if (phonelength < 4) return phonenumber;
        if (phonelength <= 6) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3)}`;
        if (phonelength > 6 && phonelength < 10) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
        if (phonelength > 10) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6, 10)} x${phonenumber.slice(10)}`;

        return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
    }

    function savePersonCallback() {
        props.onUserInfoSave(values);
    }

    function validate(name, value, displayName) {
        let testValue = value.trim();
        let key = name.replace(/_/g," ")
        if(values.extdFields && key in values.extdFields)
            values.extdFields[key] = value;
        else
        {
            switch (name) {
                case 'email':
                    if (testValue == null || testValue == "") {
                        updateError(name, requiredFieldMsg(displayName));
                    } else if (
                        !new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(testValue)
                    ) {
                        updateError(name, 'Please enter a valid email address');
                    }
                    else {
                        updateError(name);
                    }
                    break;
                    case 'guardianEmail':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else if (
                    !new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(testValue)
                ) {
                    updateError(name, 'Please enter a valid email address');
                }
                else {
                    updateError(name);
                }
                break;
                case 'phone':
                    if (testValue == null || testValue == "") {
                        updateError(name, requiredFieldMsg(displayName));
                    }
                    else {
                        testValue = formatPhoneNumber(testValue).replace(/( |-)+$/g, '');
                        if (!new RegExp(/\d{3}\/s*\d{3}-\d{4}( X\d{0,})?/gm).test(testValue)) {
                            updateError(name, 'Please enter a valid phone number in 999/999 9999 x9999 format');
                        }
                        else {
                            updateError(name);
                        }
                        value = testValue;
                    }
                    break;
                default:
                    break;
            }
        }
        return value;
    }

    return (
        values != null &&
        <form id="userinfo-form" onSubmit={handleSubmit} noValidate>
            <div className='row mt-3'>
                {values.shouldFillEmail === true &&
                    <div className="col-md-6">
                        <label htmlFor="email" className="form-label">Email</label>
                        <ValidateInput errors={errors}>
                            <input type="Email" className="form-control" id="email" name='email' value={values.email || ""} onChange={handleChange} maxLength={50}/>
                        </ValidateInput>
                    </div>
                }
                {values.shouldFillPhone === true &&
                    <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">Phone</label>
                        <ValidateInput errors={errors}>
                            <input type="text" className="form-control" id="phone" name='phone' placeholder='999/999-9999 x9999' value={values.phone || ""}
                             onChange={handleChange} maxLength={19} />
                        </ValidateInput>
                    </div>
                }
                {
                    values.guardian.requiresGuardianEmail === true &&
                    <div className="col-md-4">
                        <label htmlFor="guardianEmail" className="form-label">Guardian Email</label>
                        <ValidateInput errors={errors}>
                            <input type="guardianEmail" className="form-control" id="guardianEmail" name='guardianEmail' value={values?.guardianEmail || ""} onChange={handleChange} maxLength={50} />
                        </ValidateInput>
                    </div>
                }
            </div>
            <div className='row mt-3'></div>
            {(values.extdFields) &&
                <EditExtdFields bowlerProfile={values} />
            }
        </form>
    )
};

export default EditAlreadyMember;

